<template>
    <div>
        <div class="tenant_title">
            房源查询
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="输入查询：">
                <el-input
                    v-model="formInline.searchValue"
                    placeholder="客户姓名/地址/电话/运管姓名"
                    clearable
                ></el-input>
            </el-form-item>
            <!-- 选择时间 -->
            <el-form-item label="时间检索：" class="left_margin">
                <el-date-picker
                    v-model="time"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    size="small"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="left"
                    prefix-icon="el-icon-date"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="房型查询：" class="left_margin">
                <el-select
                    v-model="formInline.roomNumber"
                    clearable
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in roomNumber"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="房源类型：" class="left_margin">
                <el-select
                    v-model="formInline.houseType"
                    clearable
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in houseType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item
            >
            <br/>
            <el-form-item label="金额查询：" class="money">
                <el-input
                    v-model="money.moneyMin"
                    placeholder="最低价"
                    clearable
                ></el-input>
                <div class="zhi">至</div>
                <el-input
                    v-model="money.moneyMax"
                    placeholder="最高价"
                    clearable
                ></el-input>
            </el-form-item>

            <el-form-item label="所属公司：" class="left_margin">
                <el-select v-model="formInline.company" clearable placeholder="请选择">
                    <el-option
                        v-for="item in company"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="left_margin">
                <el-button type="primary" @click="LandlordAjaxList" class="inquire"
                >搜索
                </el-button
                >
                <el-button type="primary" class="reset" @click="reset">重置</el-button>
                <el-button
                    type="primary"
                    class="newBtn"
                    @click="newBtn"
                    v-if="premission('New:Listing')"
                >新建
                </el-button
                >
                <el-button type="primary" class="mapBtn" @click="switchBtn"
                >地图模式
                </el-button
                >
            </el-form-item>
        </el-form>
        <div class="newly_built" style="display: inline-flex">
            <el-button
                style="width: 120px"
                type="primary"
                class="export"
                @click="export_btn"
                v-if="premission('Distribution:Operations:Manager')"
            >分配运营管家
            </el-button
            >
            <el-button
                style="width: 120px"
                type="primary"
                class="export"
                @click="openLandlord"
                v-if="premission('Distribution:Operations:Manager')"
            >分配房东
            </el-button
            >
            <el-upload
                class="upload-demo"
                action=""
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="importHourseExcel"
            >
                <el-button
                    type="primary"
                    class="educe"
                    v-if="premission('Export:Listing:list')"
                >导入
                </el-button>
            </el-upload>

            <el-button
                type="primary"
                class="educe"
                @click="exportHourseExcel"
                v-if="premission('Export:Listing:list')"
            >导出
            </el-button
            >
            <el-button
                type="primary"
                @click="syncHouseInfo(true,'syncHouseInfo')"
            >同步美团房源至悠家
            </el-button>
            <el-button
                type="primary"
                @click="ncPigRoom(true,'ncPigRoom')"
            >同步小猪房源至悠家
            </el-button>
            <el-button
                type="primary"
                @click="syncTjRoom(true,'syncTjRoom')"
            >同步悠家房源至途家
            </el-button>
            <el-button
                type="primary"
                @click="unbindingVisible = true"
            >解绑小猪子账号
            </el-button>
            <el-button
                style="padding: 0 20px"
                type="danger"
                @click="handleBatchDelete"
            >删除
            </el-button>
        </div>
        <!-- Tabs切换 -->
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="全部房源" name="10"></el-tab-pane>
            <el-tab-pane label="待上线房源" name="1"></el-tab-pane>
            <el-tab-pane label="已上线房源" name="2"></el-tab-pane>
            <el-tab-pane label="已下架房源" name="3"></el-tab-pane>
        </el-tabs>
        <!-- 表单区域 -->
        <el-table
            v-loading="loading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <div class="terrace" v-if="scope.row.productId">
                        <div class="terrace_left">
                            <img src="../../image/mt.png"/>
                        </div>
                        <div class="platform_title">美团民宿</div>
                        <div class="terrace_center">{{ scope.row.vHousTitle }}</div>
                        <div class="terrace_right">{{ scope.row.vUploadMeiTuan }}</div>
                    </div>
                    <div class="terrace" v-if="scope.row.tj">
                        <div class="terrace_left">
                            <img src="../../image/tj.png"/>
                        </div>
                        <div class="platform_title">途家民宿</div>
                        <div class="terrace_center">{{ scope.row.vHousTitle }}</div>
                        <div class="terrace_right">{{ scope.row.vUploadTuJia }}</div>
                    </div>
                    <div class="terrace" v-if="scope.row.pigUserId">
                        <div class="terrace_left">
                            <img src="../../image/pig.png"/>
                        </div>
                        <div class="platform_title">小猪民宿</div>
                        <div class="terrace_center">{{ scope.row.vHousTitle }}</div>
                        <div class="terrace_right">{{ scope.row.vUploadSmallPig }}</div>
                    </div>
                    <div class="terrace" v-if="scope.row.aib">
                        <div class="terrace_left">
                            <img src="../../image/ai.png"/>
                        </div>
                        <div class="platform_title">爱彼迎民宿</div>

                        <div class="terrace_center">{{ scope.row.vHousTitle }}</div>
                        <div class="terrace_right">{{ scope.row.vUploadAi }}</div>
                    </div>
                    <!--                    .<div class="terrace_title">
                                            <div class="terrace_title">
                                                &lt;!&ndash; 所属公司：{{ scope.row.customer.company }} &ndash;&gt;
                                            </div>
                                            <div class="terrace_title">
                                                投资顾问：{{ scope.row.cHouAdviser }}
                                            </div>
                                            <div class="terrace_title">区域经理：{{ scope.row.cHouTalks }}</div>
                                            <div class="terrace_title">
                                                &lt;!&ndash; 设计师：{{ scope.row.cHouAdviser.cHouDispatch }} &ndash;&gt;
                                            </div>
                                        </div>-->
                </template>
            </el-table-column>
            <el-table-column prop="houseId" label="房源编号"></el-table-column>
            <el-table-column label="主图">
                <template slot-scope="scope">
                    <div class="QuickMark" @click="getImg(scope.row)">
                        <el-image
                            style="width: 100%; height: 100%"
                            :src="scope.row.houseInfoSon.vCoverPic"
                            :preview-src-list="srcList"
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="vHousTitle" label="标题" width="280">
            </el-table-column>
            <el-table-column prop="houseFavour.mDailyPrice" label="价格">
            </el-table-column>
            <el-table-column label="房型" width="180">
                <template slot-scope="scope">
                    <div>
            <span v-if="scope.row.roomNumber">{{ scope.row.roomNumber }}室</span
            ><span v-if="scope.row.hallNumber"
                    >{{ scope.row.hallNumber }}厅</span
                    ><span v-if="scope.row.bathroomNumber"
                    >{{ scope.row.bathroomNumber }}卫</span
                    ><span v-if="scope.row.kitchenNumber"
                    >{{ scope.row.kitchenNumber }}厨</span
                    ><span v-if="scope.row.balconyNumber"
                    >{{ scope.row.balconyNumber }}阳台</span
                    >
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="city" label="房源地址"></el-table-column>
            <el-table-column prop="houseInfoSon.iSameHourTotal" label="同类房源数">
            </el-table-column>
            <el-table-column label="房源状态">
                <template slot-scope="scope">
                    <div v-if="scope.row.iHourseStatus == 0">已下架</div>
                    <div v-if="scope.row.iHourseStatus == 1">待上线</div>
                    <div v-if="scope.row.iHourseStatus == 2">已上线</div>
                    <div v-if="scope.row.iHourseStatus == 3">待审核</div>
                    <div v-if="scope.row.iHourseStatus == 4">审核失败</div>
                </template>
            </el-table-column>
            <el-table-column
                v-if="activeName == 1 || activeName == 10"
                prop="houseInfoSon.cusDefine5"
                label="创建时间"
            >
            </el-table-column>
            <el-table-column v-else prop="dOnlineTime" label="上线时间">
            </el-table-column>

            <el-table-column prop="customer.customerName" label="房东姓名">
            </el-table-column>
            <el-table-column prop="cHouSteward" label="房屋管家"></el-table-column>
            <el-table-column prop="synchronousMt" label="是否已同步至美团">
                <template slot-scope="scope">
                    <span v-if="scope.row.synchronousMt==1" style="color: #F6B239">是</span>
                    <span v-if="scope.row.synchronousMt==0||!scope.row.synchronousMt">否</span>

                </template>
            </el-table-column>
            <el-table-column prop="synchronousPig" label="是否已同步至小猪">
                <template slot-scope="scope">
                    <span v-if="scope.row.synchronousPig==1" style="color: #F6B239">是</span>
                    <span v-if="scope.row.synchronousPig==0||!scope.row.synchronousPig">否</span>
                </template>
            </el-table-column>
            <el-table-column prop="synchronousTj" label="是否已同步至途家">
                <template slot-scope="scope">
                    <span v-if="scope.row.synchronousTj==1" style="color: #F6B239">是</span>
                    <span v-if="scope.row.synchronousTj==0||!scope.row.synchronousTj">否</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="140" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="details(scope.row)">查看</el-button>
                    <el-button type="text" @click="redact(scope.row)">编辑</el-button>
                    &nbsp;
                    <el-popconfirm
                        title="确定删除吗？"
                        @confirm="handleTableDelete(scope.row)"
                    >
                        <el-button type="text" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!-- <div class="checkBox"></div> -->
        <!-- 分页 -->
        <div class="paging">
            <div class="block">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 15, 20, 25,50,100]"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
        <!-- 新建弹出窗 -->
        <el-dialog title="选择房东" @close="cancel" :visible.sync="dialogVisible" width="40%">
            <el-input
                placeholder="搜索姓名/手机号"
                prefix-icon="el-icon-search"
                v-model="searchValue"
                @input="searchLandlord"
                clearable
            >
            </el-input>
            <div class="landlord">
                <div class="landlord_title">
                    <div>房东姓名</div>
                    <div>手机号</div>
                    <div>所属公司</div>
                    <div>房屋管家</div>
                </div>

                <div
                    class="title_list"
                    v-for="(item, index) in HourseLoadlist"
                    :key="index"
                >
                    <div class="list">
                        <el-radio
                            v-model="radio"
                            :label="index"
                            @change="changeRadio(item)"
                        >{{ item.nickName }}
                        </el-radio
                        >
                    </div>

                    <div class="list">{{ item.phonenumber | phone }}</div>
                    <div class="list">{{ item.company || '无' }}</div>
                    <div class="list">{{ item.cSteward }}</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" class="cancel">取 消</el-button>
        <el-button type="primary" @click="goRental" class="add_new_btn"
        >确 定</el-button
        >
      </span>
        </el-dialog>
        <!-- 分配运营管家弹窗 -->
        <el-dialog
            title="分配运营管家"
            :visible.sync="dialogVisible_export"
            width="660px"
        >
            <!-- 部门 -->
            <div class="AddLabel">
                <el-tag
                    :key="tag"
                    v-for="tag in dynamicTagsOne"
                    closable
                    type="warning"
                    :disable-transitions="false"
                    @close="handleCloseTagOne(tag)"
                >
                    {{ tag }}
                </el-tag>
            </div>
            <!-- 选择部门 -->
            <div class="select_list_tree">
                <div class="treeList">
                    <el-tree
                        accordion
                        highlight-current
                        :data="data"
                        :props="defaultProps"
                        @node-click="handleNodeClickTwo"
                    ></el-tree>
                </div>
                <div class="select_list_checkBox">
                    <!-- <div
                      class="select_list_checkBox_list"
                      v-for="(item, index) in LandlordList"
                      :key="index"
                    >
                      <el-checkbox-group
                        v-model="checkedCities"
                        @change="handleCheckAllChange"
                      >
                        <el-checkbox :label="item.deptId">{{
                          item.nickName
                        }}</el-checkbox>
                      </el-checkbox-group>
                    </div> -->
                    <el-checkbox-group
                        :max="1"
                        v-model="checkListPost"
                        @change="handleCheckAllChange"
                    >
                        <el-checkbox
                            v-for="(item, index) in LandlordList"
                            :label="item"
                            :key="index"
                        >
                            {{ item.nickName }}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" class="cancel">取 消</el-button>
                <el-button type="primary" class="success_Btn" @click="ChangeStatus"
                >确 定
                </el-button
                >
            </div>
        </el-dialog>
        <!-- 分配房东  -->
        <el-dialog title="分配房东" @close="closeLandlord"
                   :visible.sync="assignLandlordVisible" width="40%">
            <el-input
                placeholder="搜索姓名/手机号"
                prefix-icon="el-icon-search"
                v-model="searchValue"
                @input="searchNewLandlord"
                clearable
            >
            </el-input>
            <div class="landlord">
                <div class="landlord_title">
                    <div>房东姓名</div>
                    <div>手机号</div>
                    <div>所属公司</div>
                    <div>房屋管家</div>
                </div>

                <div
                    class="title_list"
                    v-for="(item, index) in HourseLoadlist"
                    :key="index"
                >
                    <div class="list">
                        <el-radio
                            v-model="radio"
                            :label="index"
                            @change="changeRadio(item)"
                        >{{ item.nickName }}
                        </el-radio
                        >
                    </div>

                    <div class="list">{{ item.phonenumber | phone }}</div>
                    <div class="list">{{ item.company || '无' }}</div>
                    <div class="list">{{ item.cSteward }}</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="assignLandlordVisible = false" class="cancel">取 消</el-button>
        <el-button type="primary" @click="handleAssignLandlord" class="add_new_btn"
        >确 定</el-button
        >
      </span>
        </el-dialog>
<!--        解绑小猪子账号-->
        <el-dialog
            title="解绑小猪子账号"
            :visible.sync="unbindingVisible"
        >
          <el-form :model="unbindingFrom">
              <el-form-item label="手机号">
                  <el-input style="width: 80%" v-model="unbindingFrom.phone" maxLength="11" placeholder="请输入手机号码"/>
              </el-form-item>
          </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="unbindingCancel" class="cancel" >取 消</el-button>
                <el-button type="primary" class="success_Btn" @click="unbindingSubmit"
                >确 定
                </el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {money} from "../../utils/treating";
import {
    hourselist,
    LandlordTreeselectListsAjax,
    TreeselectListsAjax,
    selectHourseLoadlist,
    UserListsAjax,
    manySteward,
    exportHourseExcel,
    landlordSearch, syncMtProduct, syncPigProduct, authorize,
    elRefreshToken, refresh, importExcel, synchronization,
    inventory, deleteHouse, getInventory, gcj02ToBd09ll,
    unbindingPig,updateHouseLandlord
} from "../../api/index";
import premission from "../../utils/permission";
import {downloadExcel} from '@/utils/util'
import store from "@/store";

export default {
    mixins: [premission],
    filters: {
        phone: function (item) {
            if (item == null) return;
            return item.substr(0, 3) + "****" + item.substr(7);
        }
    },
    data() {
        return {
            flg: true,
            unbindingVisible:false,
            assignLandlordVisible:false,
            radioUserId: '',
            options: [
                {
                    value: "选项1",
                    label: "黄金糕"
                },
                {
                    value: "选项2",
                    label: "双皮奶"
                },
                {
                    value: "选项3",
                    label: "蚵仔煎"
                },
                {
                    value: "选项4",
                    label: "龙须面"
                },
                {
                    value: "选项5",
                    label: "北京烤鸭"
                }
            ],
            switchBtnNum: "2",
            dataList: [
                {
                    label: "一级 1",
                    children: [
                        {
                            label: "二级 1-1",
                            children: [
                                {
                                    label: "三级 1-1-1"
                                }
                            ]
                        }
                    ]
                },
                {
                    label: "一级 2",
                    children: [
                        {
                            label: "二级 2-1",
                            children: [
                                {
                                    label: "三级 2-1-1"
                                }
                            ]
                        },
                        {
                            label: "二级 2-2",
                            children: [
                                {
                                    label: "三级 2-2-1"
                                }
                            ]
                        }
                    ]
                },
                {
                    label: "一级 3",
                    children: [
                        {
                            label: "二级 3-1",
                            children: [
                                {
                                    label: "三级 3-1-1"
                                }
                            ]
                        },
                        {
                            label: "二级 3-2",
                            children: [
                                {
                                    label: "三级 3-2-1"
                                }
                            ]
                        }
                    ]
                }
            ],
            defaultProps: {
                children: "children",
                label: "label"
            },
            houseIndex: "",
            zoom: 5,
            unbindingFrom:{
                phone:''
            },
            labelcss: {
                // width: "100px",
                // height: "42px",
                color: "#FFF",
                fontSize: "12px",
                border: "1px solid #F6B439",
                borderRadius: "4px",
                backgroundColor: "#F6B439"
            },
            labelcss2: {
                // width: "100px",
                // height: "42px",
                color: "#FFF",
                fontSize: "12px",
                border: "1px solid #219653",
                borderRadius: "4px",
                backgroundColor: "#219653"
            },
            city: [
                {
                    name: "测试1",
                    lng: 96.650961,
                    lat: 39.953068,
                    num: "2"
                },
                {
                    name: "测试1",
                    lng: 106.650961,
                    lat: 22.953068,
                    num: "3"
                },
                {
                    name: "测试1",
                    lng: 116.650961,
                    lat: 40.953068,
                    num: "5"
                }
            ],
            markers: [],
            throttle: true,
            cSteward: "",
            cStewardId: "",
            Inline: {
                pageNum: 1,
                pageSize: 30,
                userName: "",
                deptPost: "",
                deptId: "100"
            },
            checkListPostList: "", //获取的管家id
            data: [],
            dynamicTagsOne: "",
            checkListPost: [],
            LandlordList: [],
            exportList: {
                houseIds: [],
                cStewardId: "", //管家id
                cHouSteward: "", //管家姓名
                houseVoList: [],//导出的房源列表
            },
            // 时间
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            addtitleList: "选择部门",
            // 客户id
            customerId: "",
            // 单选
            radio: "",
            // 搜索
            searchValue: "",
            syncHouseFlag: '',//同步标识
            // 新建弹窗
            dialogVisible: false,
            dialogVisible_export: false,
            // 房东列表
            // defaultProps: {
            //   children: "children",
            //   label: "label"
            // },
            HourseLoadlist: [],
            deptOptions: [],
            total: 0,
            currentPage: 1,
            // 消费金额
            money: {
                moneyMin: "",
                moneyMax: ""
            },
            // 搜索条件
            time: [],
            iHourseStatus: "2", //已下架 1：待上线 2：已上线 3：待审核
            formInline: {
                company: "",
                houseType: "",
                roomNumber: "",
                pageNum: 1,
                pageSize: 5,
                searchValue: undefined,
                cStewardId:sessionStorage.getItem('userId')
            },
            loading: true,
            srcList: [],
            tableData: [],
            company: [],
            roomNumber: [
                {
                    value: 1,
                    label: "1室"
                },
                {
                    value: 2,
                    label: "2室"
                },
                {
                    value: 3,
                    label: "3室"
                },
                {
                    value: 4,
                    label: "4室"
                },
                {
                    value: 5,
                    label: "5室"
                },
                {
                    value: 6,
                    label: "6室"
                },
                {
                    value: 7,
                    label: "7室"
                },
                {
                    value: 8,
                    label: "8+室"
                }
            ],

            houseType: [
                {
                    value: 0,
                    label: "个人房东"
                },
                {
                    value: 1,
                    label: "悠家自营房东"
                }
            ],
            activeName: "2",
            //房东列表查询条件
            landlordFrom: {
                customerName: '',
                phonenumber: ''
            }
        };
    },

    created() {
        this.LandlordAjaxList();
        this.getTreeselectListsAjax();
        this.city = [
            {
                name: "测试1",
                lng: 96.650961,
                lat: 39.953068,
                id: "1",
                num: "2"
            },
            {
                name: "测试1",
                lng: 106.650961,
                lat: 22.953068,
                id: "2",
                num: "3"
            },
            {
                name: "测试1",
                lng: 116.650961,
                lat: 40.953068,
                id: "3",
                num: "5"
            }
        ];
    },
    mounted() {
        for (let i = 0; i < 12; i++) {
            let position = {
                lng: Math.random() * 40 + 85,
                lat: Math.random() * 30 + 21
            };
            this.markers.push(position);
        }


    },
    methods: {
        //手机号名称搜索房东
        searchLandlord(data) {
            if (this.flg !== null) {
                clearTimeout(this.flg);
            }
            this.flg = setTimeout(() => {
                let reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                if (!Number.isNaN(parseInt(data)) || reg.test(data)) {
                    this.landlordFrom.phonenumber = data;
                } else {
                    this.landlordFrom.customerName = data;
                }

                console.log("防抖", data)
                this.newBtn()
            }, 500)

        },
        searchNewLandlord(data) {
            if (this.flg !== null) {
                clearTimeout(this.flg);
            }
            this.flg = setTimeout(async () => {
                let reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                if (!Number.isNaN(parseInt(data)) || reg.test(data)) {
                    this.landlordFrom.phonenumber = data;
                } else {
                    this.landlordFrom.customerName = data;
                }

                console.log("防抖", data)
                const {data: res} = await landlordSearch(this.landlordFrom);
                if (res.code !== 200) {
                    return this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
                this.HourseLoadlist = res.data;

                this.landlordFrom = {
                    customerName: '',
                    phonenumber: ''
                }
            }, 500)

        },
        //授权美团
        authMt() {
            authorize({
                uri: 'https://test.youjiaminsu.cn/dist/auth'
            }).then(result => {
                console.log(result, '获取美团授权地址')
                // alert(result.data.data)

                setTimeout(() => {
                    this.$confirm('你还没有授权美团账号，是否前往授权?', '提示', {
                        confirmButtonText: '去授权',
                        cancelButtonText: '稍后再说',
                        type: 'warning'
                    }).then(() => {
                        window.location = result.data.data;
                    }).catch(() => {
                        localStorage.setItem('isAuthMt', 'cancelAuth')
                    });
                }, 1500)
            })
        },
        //切换按钮
        switchBtn() {
            this.$emit("switchBtnNum", this.switchBtnNum);
        },
        //导入
        importHourseExcel(data) {
            console.log(data)
            let fromData = new FormData();
            fromData.append("file", data.raw)

            importExcel(fromData).then(res => {
                console.log(res)
                if (res.data.code == 0) {
                    this.$message.success('导入成功')
                    this.LandlordAjaxList();
                } else {
                    this.$message.error(res.data.msg)
                }

            })
        },
        //导出房源列表
        async exportHourseExcel() {
            console.log(this.exportList)
            let hourseVosList = []

            function getIHoursestatus(iHourseStatus) {
                console.log(iHourseStatus)
                return iHourseStatus == 0 ? '已下架' : iHourseStatus == 1 ? '待上线' : iHourseStatus == 2 ? '已上线' : iHourseStatus == 3 ? '待审核' : '审核失败'
            }

            this.exportList.houseVoList.forEach(item => {
                hourseVosList.push({
                    houseId: item.houseId,
                    vhousTitle: item.vHousTitle,
                    mdailyPrice: item.houseFavour.mDailyPrice,
                    room: item.roomNumber + '室',
                    city: item.city,
                    isameHourTotal: item.houseInfoSon.iSameHourTotal,
                    ihourseStatus: getIHoursestatus(item.iHourseStatus),
                    donlineTime: item.dOnlineTime,
                    customerName: item.customer ? item.customer.customerName : '',
                    chouSteward: item.cHouSteward
                })
            })

            console.log(hourseVosList)
            /*company

            landlordType

            roomNumber

            searchValue*/
            let {company, landlordType, roomNumber, searchValue, houseType} = this.formInline
            let params = {
                company: company,
                houseType: houseType,
                roomNumber: roomNumber,
                searchValue: searchValue,
                ...this.formInline.params
            }
            console.log(params)
            // return;

            const {data: res} = await exportHourseExcel({
                ...params,
                hourseVosList: hourseVosList.length == 0 ? null : hourseVosList
            });
            if (res.code == 200) {
                this.$message.success("导出成功")
                downloadExcel({fileName: res.msg, delete: true})
            }


        },
        //获取树形结构数据
        async getTreeselectListsAjax() {
            const {data: res} = await TreeselectListsAjax({

            });
            if (res.code !== 200)
                return this.$message({
                    message: res.msg,
                    type: "error"
                });
            this.data = res.data;
        },
        //房东列表查询
        async newBtn() {
            this.dialogVisible = true;
            // const { data: res } = await selectHourseLoadlist(this.landlordFrom);
            console.log(this.landlordFrom)
            const {data: res} = await landlordSearch(this.landlordFrom);
            if (res.code !== 200) {
                return this.$message({
                    message: res.msg,
                    type: "error"
                });
            }
            this.HourseLoadlist = res.data;

            this.landlordFrom = {
                customerName: '',
                phonenumber: ''
            }
        },
        cancel() {
            this.dynamicTagsOne = "";
            this.checkListPost = [];
            this.exportList = {
                houseIds: [],
                cStewardId: "", //管家id
                cHouSteward: "", //管家姓名，
                houseVoList: []
            };
            this.searchValue = ''
            this.landlordFrom = {
                customerName: '',
                phonenumber: ''
            }
            this.dialogVisible = false;
            this.dialogVisible_export = false;
            this.radio = ''
        },

        reset() {
            this.formInline = {
                company: "",
                landlordType: "",
                roomNumber: "",
                pageNum: 2,
                pageSize: 5,
                searchValue: undefined
            };
            this.iHourseStatus = "10";
            this.time = [];
            this.money = {
                moneyMin: "",
                moneyMax: ""
            };
            this.LandlordAjaxList();
        },
        // 全选
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        // 反选
        handleSelectionChange(val) {
            console.log(val)
            this.exportList.houseVoList = val;
            this.exportList.houseIds = val.map(e => {
                return e.houseId;
            });
        },
        // 获取表单数据
        async LandlordAjaxList() {
            if (!this.throttle) return;
            this.throttle = false;
            this.loading = true;
            console.time("表格接口耗时")
            if(this.formInline.cStewardId==1){
                delete this.formInline.cStewardId
            }
            const {data: res} = await hourselist(
                money(this.formInline, this.money, this.time, this.activeName),
            );
            this.throttle = true;
            this.tableData = res.rows;
            this.total = res.total;
            this.loading = false
            console.timeEnd('表格接口耗时')
            //同步美团数据到悠家
            console.log(this.$store.state.MT_token)
            /*if(this.$store.state.MT_token){
                this.tableData.forEach(item=>{
                    console.log("cutsomerId",item.customerId)
                    syncMtProduct({customerId:item.customerId}).then(res=>{

                    })
                })

            }*/

        },
        // 分页
        handleSizeChange(val) {
            this.formInline.pageSize = val;
            this.LandlordAjaxList();
        },
        handleCurrentChange(val) {
            this.formInline.pageNum = val;
            this.LandlordAjaxList();
        },
        // 操作
        details(e) {
            console.log(e);
            this.$router.push({
                name: "productDetails", //跳转的路径
                params: {
                    houseId: e.houseId,
                    productId: e.productId,
                    customerId: e.customer?.customerId
                }
            });
        },
        //编辑
        redact(e) {
            console.log(e)
            this.$router.push({
                name: "rental", //跳转的路径
                query: {
                    houseId: e.houseId,
                    customerId: e.customerId,
                    isStatus: 1,
                    roomId: e.roomId,
                    pigUserId: e.pigUserId
                }
            });
        },
        getImg(row) {
            this.srcList = [];
            this.srcList.push(row.houseInfoSon.vCoverPic);
        },

        changeRadio(e) {
            console.log(e)
            this.cSteward = e.cSteward;
            this.cStewardId = e.cStewardId;
            this.customerId = e.customerId;
            this.radioUserId = e.userId;
        },
        goRental() {
            console.log(this.customerId)
            if (this.customerId == "") return;
            if (!this.syncHouseFlag) {
                this.$router.push({
                    name: "rental", //跳转的路径
                    query: {
                        customerId: this.customerId,
                        cStewardId: this.cStewardId,
                        cSteward: this.cSteward
                    }
                });
            } else {
                console.log("cutsomerId", this.customerId)
                if (this.syncHouseFlag == 'ncPigRoom') {
                    syncPigProduct({customerId: this.radioUserId}).then(({data}) => {
                        if (data && data.code === 200) {
                            this.$message.success(data.msg)
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    syncMtProduct({customerId: this.customerId}).then(({data}) => {
                        console.log(data)
                        if (data && data.code === 200) {
                            this.$message.success(data.msg)
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }
                this.syncHouseInfo(false, '')
            }

        },
        handleClick(tab) {
            this.formInline.pageNum = 1;
            this.iHourseStatus = tab.name;
            this.LandlordAjaxList();
        },
        // 分配
        export_btn() {
            this.dialogVisible_export = true;
        },
        closeLandlord(){
            this.searchValue = ''
            this.exportList = {
                houseIds: [],
                cStewardId: "", //管家id
                cHouSteward: "", //管家姓名，
                houseVoList: []
            }
            this.radio = '';
            this.cSteward = '';
            this.cStewardId = '';
            this.customerId = '';
            this.radioUserId ='';
            this.assignLandlordVisible = false;
            this.$refs.multipleTable.clearSelection();

        },
       async openLandlord(){
            if (this.exportList.houseIds.length < 1)
                return this.$message({
                    message: "分配房东需选择房源",
                    type: "error"
                });
          /* if (this.exportList.houseIds.length >1)
               return this.$message({
                   message: "只可选择一套房源进行分配",
                   type: "error"
               });*/
            const {data: res} = await landlordSearch(this.landlordFrom);
            if (res.code !== 200) {
                return this.$message({
                    message: res.msg,
                    type: "warning"
                });
            }
            this.HourseLoadlist = res.data;

            this.landlordFrom = {
                customerName: '',
                phonenumber: ''
            }
           this.assignLandlordVisible = true;
        },
       async handleAssignLandlord(){
            console.log(this.exportList)
           if(!this.customerId){
               return this.$message.warning('请选择房东')
           }
            this.assignLandlordVisible = false;
            let from =  {
                customerId:this.customerId,
                list: this.exportList.houseIds
            }
           const {data: res} = await updateHouseLandlord(from);
           if (res.code !== 200)
               return this.$message({
                   message: res.msg,
                   type: "error"
               });
           this.$message.success('操作成功');

           this.assignLandlordVisible = false;
           this.LandlordAjaxList();
        },
        // 新增树形
        handleNodeClickTwo(data) {
            this.Inline = {
                pageNum: 1,
                pageSize: 30,
                userName: "",
                deptPost: "",
                deptId: "100"
            };
            this.Inline.deptId = data.id;
            this.onSubmit();
        },
        async onSubmit() {
            const {data: res} = await UserListsAjax(this.Inline);
            if (res.code !== 200)
                return this.$message({
                    message: res.msg,
                    type: "error"
                });
            this.LandlordList = res.rows;
        },
        // Tag删除标签

        handleCheckAllChange(val) {
            console.log(val)
            // this.dynamicTagsOne = [];
            // this.checkListPostList = [];
            this.dynamicTagsOne = val.map(item => {
                return item.userName;
            });
            this.checkListPostList = this.checkListPost.map(item => {
                return item.userId;
            });
            console.log(this.checkListPostList, this.dynamicTagsOne);
        },
        handleCloseTagOne(tag) {
            this.dynamicTagsOne.splice(this.dynamicTagsOne.indexOf(tag), 1);

            for (var k in this.checkListPost) {
                if (this.dynamicTagsOne.indexOf(this.checkListPost[k].postName) == -1) {
                    this.checkListPost.splice(k, 1);
                    return;
                }
            }
        },
        async ncPigRoom(show, syncHouseFlag) {
            this.syncHouseFlag = syncHouseFlag;//同步标识
            this.dialogVisible = show
            if (show) {
                console.log(this.landlordFrom)
                const {data: res} = await landlordSearch(this.landlordFrom);
                if (res.code !== 200) {
                    return this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
                this.HourseLoadlist = res.data;

                this.landlordFrom = {
                    customerName: '',
                    phonenumber: ''
                }
            }
        },
        //同步途家房源信息
        async syncTjRoom(show, syncHouseFlag) {
            this.syncHouseFlag = syncHouseFlag;//同步标识
            console.log(this.exportList)
            if (this.exportList.houseIds.length == 0) {
                this.$message.warning('请选择需要同步的房源')
                return;
            }
           /* const baiduRes =   await gcj02ToBd09ll({
                coords:this.exportList.houseVoList[0].longtitude+','+this.exportList.houseVoList[0].latitude,
                ak:'uIiMzAo73t8g8ovR9qvILMYVhp7SskBk',
                from:3,
                to:5
            });
            if(baiduRes.data.status!=0){
                this.$message.error('坐标转换失败,请检查后重试')
                return;
            }*/
            const {data: syncRes} = await synchronization({houseId: this.exportList.houseIds[0]});
            if (syncRes.code !== 200) {
                this.$confirm(syncRes.msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                }).catch(() => {

                });

                return;
            }
           let data =  await this.getInventory(this.exportList.houseIds[0],this.exportList.houseVoList[0].vHousTitle);
            console.log('data====>',data.data.data)
             this.updateTjInventory(data.data.data)
            // this.updateTjInventory(this.exportList.houseIds[0])
            this.$message.success('同步成功');
            this.LandlordAjaxList();
        },
        async syncHouseInfo(show, syncHouseFlag) {
            this.syncHouseFlag = syncHouseFlag;//同步标识
            this.dialogVisible = show
            if (show) {
                console.log(this.landlordFrom)
                const {data: res} = await landlordSearch(this.landlordFrom);
                if (res.code !== 200) {
                    return this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
                this.HourseLoadlist = res.data;

                this.landlordFrom = {
                    customerName: '',
                    phonenumber: ''
                }
            }
        },
        async ChangeStatus() {
            this.exportList.cStewardId = this.checkListPostList.toString(); //管家id
            this.exportList.cHouSteward = this.dynamicTagsOne.toString(); //管家姓名
            if (this.exportList.houseIds.length < 1)
                return this.$message({
                    message: "批量分配房源需选择房源",
                    type: "error"
                });

            const {data: res} = await manySteward(this.exportList);
            if (res.code !== 200)
                return this.$message({
                    message: res.msg,
                    type: "error"
                });
            this.exportList = {
                cStewardId: "",
                cHouSteward: "",
                houseIds: "",
                houseVoList: []
            };
            this.dynamicTagsOne = "";
            this.checkListPost = [];
            this.dialogVisible_export = false;
            this.LandlordAjaxList();
            return this.$message({
                message: res.msg,
                type: "success"
            });
        },
        getInventory(houseId,title){
           return  getInventory({houseId,title});
        },
        updateTjInventory(data) {
            //status 0修改房态 1修改房价
            //  selectData noSlects

            let params = {
                partner_uid: data.partner_uid,
                partner_pid:data.partner_pid,
            };

            params['inventorys'] = data.inventorys
            params['prices'] = data.prices
            console.log('途家入参===>', params)
            return inventory(params);
        },
        async handleBatchDelete() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
          await  deleteHouse(this.exportList.houseIds).then(res => {
                loading.close();
                if (res.data.code === 200) {
                    this.$message({type: 'success', message: '删除成功'})
                    this.$refs.multipleTable.clearSelection();
                     this.LandlordAjaxList();
                } else {
                    this.$message({type: 'error', message: res.data.msg})
                }
            })
        },
        handleTableDelete(row) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            deleteHouse([row.houseId]).then(res => {
                loading.close();
                if (res.data.code === 200) {
                    this.$message({type: 'success', message: '删除成功'})
                    this.LandlordAjaxList();
                } else {
                    this.$message({type: 'error', message: res.data.msg})
                }
            })
        },
        unbindingCancel(){
          this.unbindingVisible = false;
          this.unbindingFrom.phone = '';
        },
        unbindingSubmit(){
            if(!this.unbindingFrom.phone){
                return this.$message.warning("请输入手机号")
            }
            unbindingPig(this.unbindingFrom).then(res=>{
                if (res.data.code === 200) {
                    this.$message({type: 'success', message: '解绑成功'})

                } else {
                    this.$message({type: 'error', message: res.data.msg})
                }
                this.unbindingVisible = false;
                this.unbindingFrom.phone = '';
            })

        }

    }
};
</script>

<style lang="less" scoped>
.tenant_title {
    width: 72px;
    height: 24px;
    font-size: 18px;
    line-height: 24px;
    color: #171a1e;
    margin-bottom: 20px;
}

/deep/ .demo-form-inline {
    .el-input__inner {
        width: 220px;
        height: 36px;
        font-size: 14px;
    }

    .left_margin {
        margin-left: 26px;

        .newBtn {
            width: 72px;
            height: 36px;
            background-color: #219653;
            border: 1px solid #219653;
        }

        .reset {
            width: 72px;
            height: 36px;
            background-color: #f6b439;
            border: 1px solid #f6b439;
        }

        .mapBtn {
            width: 96px;
            height: 36px;
            background-color: #2f80ed;
            border: 1px solid #2f80ed;
        }
    }

    .inquire {
        width: 72px;
        height: 36px;
        margin-top: 2px;
        margin-left: -12px;
    }

    .el-button + .el-button {
        margin-left: 24px;
        // width: 72px;
        height: 36px;
    }
}

/deep/ .el-range-separator {
    width: 10%;
}

/deep/ .el-range-editor.el-input__inner {
    float: left;
    margin-top: 2px;
}

/deep/ .el-date-editor .el-range-separator {
    line-height: 28px;
}

.newly_built {
    margin-top: 18px;
    margin-bottom: 20px;

    .newly_built_btn {
        width: 80px;
        background-color: #f6b439;
        border: 1px solid #f6b439;
    }

    .educe {
        background-color: #2f80ed;
        border: #2f80ed;
        width: 72px;
    }

    .export {
        background-color: #f6b439;
        border: #f6b439;
        width: 72px;
    }

    .el-button {
        text-align: center;
        padding: 0;
        height: 36px;
        margin-right: 14px;
    }
}

.money {
    margin-left: 26px;

    /deep/ .el-form-item__content {
        width: 244px;
        padding-top: 3px;
    }

    div {
        float: left;
    }

    .zhi {
        width: 44px;
        text-align: center;
    }

    /deep/ .el-input {
        width: 100px;
    }

    /deep/ .el-input__inner {
        padding-left: 25px;
        float: left;
        width: 100px;
        height: 36px;
    }
}

.checkBox {
    width: 100%;
    height: 50px;
    background: #f2f2f2;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
    border-radius: 0px;
}

.el-form-item:nth-last-child(3) {
    margin-left: 0;
}

.paging {
    margin-top: 40px;
    margin-left: 15%;
    // margin-left: 610px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #f6b439;
}

/deep/ .el-table th,
.el-table tr {
    text-align: center;
}

/deep/ .el-table td,
.el-table th.is-leaf {
    text-align: center;
}

.QuickMark {
    width: 50px;
    height: 36px;
    margin-left: 50%;
    transform: translateX(-50%);
}

.terrace {
    margin-left: 124px;
    height: 40px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;

    .terrace_left,
    .terrace_center,
    .terrace_right {
        font-size: 14px;
        line-height: 40px;

    }

    .terrace_left {
        img {
            width: 40px;
            height: 40px;
            display: flex;
        }

        margin-right: 71px;
    }

    .terrace_center {
        margin-right: 47px;
    }

    .platform_title {
        margin-right: 47px;
        float: left;
        width: 7%;
        text-align: left;
    }
}

.terrace_title {
    margin-top: 10px;
    margin-left: 124px;
    height: 40px;

    .terrace_title {

        line-height: 40px;
    }
}

/deep/ .el-table__expanded-cell {
    padding: 15px 50px;
}

.dialog-footer {
    .add_new_btn {
        margin-left: 24px;
        width: 72px;
        height: 36px;
        background-color: #f6b439;
        border: 1px solid #f6b439;
        box-sizing: border-box;
        border-radius: 4px;
    }

    .cancel {
        width: 72px;
        height: 36px;
        background-color: #f2f2f2;
        border: 1px solid #e1e1e1;
        box-sizing: border-box;
        border-radius: 4px;
    }
}

.el-dialog__header {
    padding: 30px;
    font-size: 20px;
}

/deep/ .el-dialog__body {
    padding: 30px 60px;
}

/deep/ .el-dialog__footer {
    padding: 10px 60px 44px;
}

.landlord {
    max-height: 520px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 50px;

    .landlord_title {
        display: flex;
        height: 40px;
        justify-content: space-between;
        border-bottom: 1px solid #e1e1e1;
        div {
            width: 200px;
            text-align: center;
        }
    }

    .title_list {
        height: 60px;
        line-height: 60px;
        position: relative;
        border-bottom: 1px solid #e1e1e1;
        width: 100%;
        display: flex;
        justify-content: space-between;
        .list{
            width: 200px;
            text-align: center;
        }
       /* .list {
           !* position: absolute;
            left: 0;*!
            width: 160px;
            margin: 0 20px;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
        }*/

       /* .list:nth-child(2) {
            left: 183px;
        }

        .list:nth-child(3) {
            left: 378px;
        }

        .list:nth-child(4) {
            left: 558px;
            width: 150px;
        }*/
    }
}

/deep/ .el-tabs__active-bar {
    background-color: #f6b439;
}

/deep/ .el-tabs__item.is-active {
    color: #f6b439;
}

/deep/ .el-tabs__item:hover {
    color: #f6b439;
}

.AddLabel {
    width: 540px;
    min-height: 42px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    margin-bottom: 24px;

    .el-tag.el-tag--warning {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
    }
}

.select_list_tree {
    overflow: hidden;
    width: 540px;
    padding: 20px 30px;
    border: 1px solid #e1e1e1;

    .treeList {
        float: left;
        width: 280px;
    }

    .select_list_checkBox {
        padding: 0 50px 0 30px;
        float: right;
        width: 198px;
        border-left: 1px solid #e1e1e1;
        height: 300px;
        overflow: auto;
        .select_list_checkBox_list {
            width: 100%;
            height: 32px;
        }
    }
}

.cancel {
    width: 72px;
    height: 36px;
    background-color: #f2f2f2;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    border-radius: 4px;
}

.success_Btn {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
    box-sizing: border-box;
    border-radius: 4px;
}

// // 地图区域
// .MapBox {
//   position: relative;
//   width: 100%;
//   height: 830px;
//   .map {
//     width: 100%;
//     height: 100%;
//   }
//   .MapHouseList {
//     position: absolute;
//     padding: 15px;
//     left: 0;
//     top: 0px;
//     width: 470px;
//     height: 100%;
//     overflow-y: auto;
//     box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
//     background-color: #fff;
//     .HouseBoxList {
//       cursor: pointer;
//       width: 100%;
//       height: 130px;
//       border: 1px solid rgba(0, 0, 0, 0.1);
//       margin-bottom: 15px;
//       padding: 15px;
//       display: flex;
//       .BoxListImg {
//         overflow: hidden;
//         border-radius: 5px;
//         width: 160px;
//         height: 100px;
//         flex: none;
//         img {
//           width: 100%;
//           height: 100%;
//         }
//       }
//       .HouseInfo {
//         flex: 1;
//         height: 100px;
//         width: 226px;
//         padding-left: 10px;
//         .HouseInfoTitle {
//           width: 100%;
//           color: #000000;
//           font-size: 18px;
//           line-height: 25px;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }
//         .HouseRoom {
//           margin: 8px 0;
//           font-size: 14px;
//           line-height: 20px;
//           color: #666666;
//           .Price {
//             float: right;
//             margin-right: 40px;
//             color: #f62a2a;
//           }
//           .HouseSize {
//             line-height: 25px;
//           }
//         }
//       }
//     }
//     .HouseBoxList:hover {
//       background-color: #f6b439;
//     }
//   }
//   .CityList {
//     position: absolute;
//     padding: 0px 60px;
//     padding-top: 44px;
//     overflow-y: auto;
//     top: 20px;
//     left: 20px;
//     width: 320px;
//     height: 785px;
//     background-color: #fff;
//     box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
//   }
//   /deep/.bmap {
//     background-color: #fff;
//   }
// }
</style>
